module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "tabs": ""
    }
  }, [_c('ul', {
    class: _vm.navStyleClass,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.headers), function(header) {
    return [(header._isTab) ? _c('li', {
      class: {
        active: header.active, disabled: header.disabled
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(header)
        }
      }
    }, [_vm._t("header", [_c('a', {
      attrs: {
        "href": "#"
      },
      domProps: {
        "innerHTML": _vm._s(header.header)
      }
    })])], 2) : _vm._e(), _vm._v(" "), (header._isTabGroup) ? _c('dropdown', {
      class: {
        active: header.active
      },
      attrs: {
        "text": header.header,
        "disabled": header.disabled
      }
    }, _vm._l((header.tabs), function(tab) {
      return _c('li', {
        class: {
          disabled: tab.disabled
        }
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.select(tab)
          }
        }
      }, [_vm._v(_vm._s(tab.header))])])
    })) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3df2f97d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3df2f97d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tabs.vue
// module id = 200
// module chunks = 0